import { baseFetch } from "./base";
import { pingSocketAfterSubmit } from "../utils/socket";

interface ButtonPressData {
  user_id: string;
  message_id: string;
  data: string[];
  tab_id?: string;
}

export const sendButtonPress = async (data: ButtonPressData) => {
  try {
    const response = await baseFetch.post("/button_press", data);
    pingSocketAfterSubmit();
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error("Error while sending button press:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const getMainMenu = async () => {
  try {
    const response = await baseFetch.get("/menu");
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error("Error while fetching menu:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};
